import { render, staticRenderFns } from "./SurfaceTemperatureScatter.vue?vue&type=template&id=0b1ab541&"
import script from "./SurfaceTemperatureScatter.vue?vue&type=script&lang=js&"
export * from "./SurfaceTemperatureScatter.vue?vue&type=script&lang=js&"
import style0 from "./SurfaceTemperatureScatter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports